import React from "react";
import { Link } from "react-router-dom";
import publicationsHeroBg from "../../assets/BG-1.png";
// import subscribeGraphic from "../../assets/Subimage.png";
import trustBg from "../../assets/BG-2.png";
import demoImg from "../../assets/Demoimg.png";
import PublicationsDocumentGrid, {
	featuredDocuments,
	FEATURED_WHITE_PAPER_PATH,
} from "./PublicationsDocumentGrid";
import "./PublicationsPage.css";
import { Header } from "../PageTemplate/Header";
import { Footer } from "../PageTemplate/Footer";

/* ─────────────────────────────────────────────
   Main Component
───────────────────────────────────────────── */
const PublicationsPage = () => {
	// const [formData, setFormData]   = useState({ fullName: "", email: "" });
	// const [subscribed, setSubscribed] = useState(false);

	// const handleSubscribe = (e) => {
	//   e.preventDefault();
	//   if (formData.fullName && formData.email) setSubscribed(true);
	// };

	return (
		<div
			style={{ margin: 0, padding: 0, background: "#ffffff", zoom: 0.97 }}
		>
			<div
				style={{
					width: "100%",
					height: "100%",
					background: "white",
					overflow: "hidden",
					flexDirection: "column",
					justifyContent: "flex-start",
					alignItems: "flex-start",
					display: "inline-flex",
				}}
			>
				<Header />

				{/* ── HERO ── */}
				<section
					className="w-full flex justify-center px-4 sm:px-6 lg:px-8 pt-10 pb-5"
					aria-label="Publications hero"
				>
					<div
						className="relative w-full max-w-[1204px] rounded-[28px] overflow-hidden bg-[#0d1b3e] bg-cover bg-center bg-no-repeat shadow-[0_16px_40px_rgba(15,23,42,0.12)]"
						style={{
							backgroundImage: `url(${publicationsHeroBg})`,
						}}
					>
						<div
							className="absolute inset-0 bg-[linear-gradient(180deg,rgba(5,9,20,0.9)_0%,rgba(6,11,24,0.82)_38%,rgba(8,13,28,0.72)_100%)] lg:hidden"
							aria-hidden="true"
						/>
						<div className="relative z-10 flex min-h-[320px] items-center gap-10 px-6 py-8 sm:px-8 sm:py-10 lg:min-h-[340px] lg:px-10 xl:px-12">
							<div className="flex max-w-[560px] flex-1 flex-col gap-5">
								<span className="inline-flex w-fit items-center rounded-full border border-white/35 px-3.5 py-1.5 text-xs font-semibold tracking-widest text-white">
									PUBLICATIONS &amp; KNOWLEDGE HUB
								</span>
								<h1 className="m-0 font-bold leading-tight text-white text-[30px] sm:text-[38px] lg:text-[50px]">
									Explore the{" "}
									<span className="text-[#367AE4]">
										insights
									</span>
									,{" "}
									<span className="text-[#367AE4]">
										research
									</span>
									, and{" "}
									<span className="text-[#367AE4]">
										documents
									</span>{" "}
									shaping trusted digital credentials.
								</h1>
								<p className="m-0 max-w-lg text-[16px] leading-relaxed text-white/75">
									Access white papers, official publications,
									briefs, and supporting resources designed to
									educate institutions, partners, and the
									wider public.
								</p>
								<div className="mt-2 flex flex-wrap gap-3.5">
									{/* <Link
                  to={PUBLICATIONS_LIBRARY_PATH}
                  className="min-h-[48px] rounded-[8px] border border-white bg-white px-6 py-3 text-[14px] font-medium text-[#151b2d] no-underline shadow-[0_4px_14px_rgba(255,255,255,0.08)] transition-all hover:bg-white/95"
                >
                  Browse Library
                </Link> */}
									<Link
										to={FEATURED_WHITE_PAPER_PATH}
										className="inline-flex min-h-[48px] items-center justify-center rounded-[8px] border border-white/20 bg-white/6 px-6 py-3 text-[14px] font-medium text-white no-underline shadow-[inset_0_1px_0_rgba(255,255,255,0.08)] bg-white/20 transition-all hover:bg-white/10"
									>
										View Latest White Paper
									</Link>
								</div>
							</div>

							<div
								className="hidden flex-1 lg:block"
								aria-hidden="true"
							/>
						</div>
					</div>
				</section>

				{/* ── FEATURED READING ── */}
				<section
					className="w-full flex justify-center px-4 sm:px-6 lg:px-8 pt-12 pb-4 py-16"
					aria-label="Featured reading"
				>
					<div className="w-full max-w-[1204px] flex flex-col gap-8">
						{/* Header row */}
						{/* <div className="flex justify-between items-end flex-wrap gap-4 mb-5">
            <div>
              <p className="text-blue-500 text-[16px] font-semibold mb-2">FEATURED READING</p>
              <h2 className="text-[#0d1b3e] text-3xl font-bold m-0">Documents Worth Spotlighting</h2>
            </div>
            <Link to={PUBLICATIONS_LIBRARY_PATH} className="px-5 py-3 rounded-lg border-[1px] border-[#29292966] text-[#3c414f] bg-transparent text-[14px] font-semibold cursor-pointer no-underline drop-shadow-[0_4px_3px_#0000000A]">
              View All Documents
            </Link>
          </div> */}

						{/* Cards */}
						<PublicationsDocumentGrid
							documents={featuredDocuments}
							ariaLabel="Featured reading documents"
						/>
					</div>
				</section>

				{/* ── BOOK AN ONBOARDING CONSULTATION ── */}
				<section
					className="w-full flex justify-center px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20"
					aria-label="Book a demo"
				>
					<div
						className="w-full max-w-[1204px] bg-cover bg-center rounded-2xl overflow-hidden"
						style={{ backgroundImage: `url(${trustBg})` }}
					>
						<div className="flex flex-col-reverse items-center gap-8 p-8 sm:p-10 min-[800px]:flex-row min-[800px]:gap-12 min-[800px]:p-14 lg:p-[70px]">
							{/* Left: text content */}
							<div className="flex flex-col gap-4 w-full min-[800px]:w-1/2">
								<div className="text-[#116DFD] font-semibold text-base tracking-widest uppercase">
									BOOK AN ONBOARDING CONSULTATION
								</div>
								<div className="text-white text-[26px] sm:text-[30px] font-bold leading-tight">
									See VerifyTT In Action?
								</div>
								<div className="text-white text-base leading-[1.7]">
									Discover how VerifyTT makes credentials
									secure, portable, and instantly verifiable.
									Book an onboarding consultation today and
									see how your organization can streamline
									verification with confidence.
								</div>
								<div className="mt-4">
									<a
										href="https://appointments.gov.tt/organizations/appointments/118.110"
										className="inline-block bg-white text-[#0f1623] font-bold text-[15px] px-8 py-[14px] rounded-[10px] no-underline"
									>
										Book Demo
									</a>
								</div>
							</div>
							{/* Right: graphic — hidden on small mobile, smaller on tablet */}
							<div className="hidden sm:flex justify-start items-center w-full min-[800px]:w-1/2 min-[800px]:justify-center">
								<img
									src={demoImg}
									alt="VerifyTT demo graphic"
									className="w-full max-w-[260px] sm:max-w-[320px] md:max-w-[420px] lg:max-w-[480px] h-auto object-contain"
								/>
							</div>
						</div>
					</div>
				</section>

				{/* ── SUBSCRIBE (commented out) ── */}
				{/* <section className="w-full flex justify-center px-4 py-16 sm:px-6 lg:px-8" aria-label="Subscribe for updates">
        <div
          className="w-full max-w-[1204px] overflow-hidden rounded-[28px] border border-[#1e335d] shadow-[0_18px_40px_rgba(15,23,42,0.18)]"
          style={{
            backgroundColor: "#0b1327",
            backgroundImage:
              "linear-gradient(180deg, rgba(6,11,24,0.38) 0%, rgba(8,14,29,0.18) 42%, rgba(10,18,39,0.02) 100%), linear-gradient(rgba(120, 148, 208, 0.12) 1px, transparent 1px), linear-gradient(90deg, rgba(120, 148, 208, 0.12) 1px, transparent 1px), linear-gradient(135deg, rgba(17,31,63,0.94) 0%, rgba(10,18,39,0.99) 100%)",
            backgroundSize: "auto, 76px 58px, 76px 58px, cover",
            backgroundPosition: "center, 0 0, 0 0, center",
          }}
        >
          <div className="relative flex flex-col gap-10 pb-8 lg:px-12 lg:pt-8 lg:pb-12 xl:min-h-[450px] xl:flex-row xl:items-stretch xl:justify-between">
            <div className="relative z-10 flex min-w-0 w-full flex-1 flex-col gap-3 xl:max-w-[700px] xl:justify-start">
              <p className="m-0 text-[13px] font-semibold uppercase tracking-[0.08em] text-[#2f8cff]">Stay Updated</p>
              <h2 className="m-0 max-w-full text-[36px] font-bold leading-[1.15] text-white xl:max-w-[720px]">
                Subscribe For New Publications And White Papers
              </h2>
              <p className="m-0 max-w-full text-[16px] text-white xl:max-w-[720px]">
                Get notified when new reports, research, briefs, and official documents are published.
              </p>
              <div className="relative mt-0 h-[165px] w-full max-w-full overflow-hidden sm:h-[180px] md:h-[195px] lg:mt-1 lg:h-[215px] xl:max-w-[600px]">
                <img
                  src={subscribeGraphic}
                  alt=""
                  aria-hidden="true"
                  className="pointer-events-none absolute bottom-0 left-0 h-auto w-full max-w-[500px] object-contain sm:max-w-[520px] lg:max-w-[560px]"
                />
              </div>
            </div>
            <div className="relative z-10 flex w-full max-w-full flex-col rounded-[16px] border border-[#41506f]/50 bg-[rgba(31,41,64,0.92)] p-7 shadow-[0_18px_32px_rgba(0,0,0,0.22)] backdrop-blur-[6px] sm:p-8 xl:max-w-[430px] xl:self-stretch">
              {subscribed ? (
                <div className="flex min-h-[260px] flex-1 flex-col items-center justify-center gap-4 text-center">
                  <div className="flex h-14 w-14 items-center justify-center rounded-full border border-white/10 bg-white/10 text-2xl font-bold text-white">✓</div>
                  <p className="m-0 text-lg font-semibold text-white">Thank you! You've been subscribed.</p>
                  <p className="m-0 max-w-[280px] text-sm leading-relaxed text-white/65">
                    We'll let you know when new publications and white papers are available.
                  </p>
                </div>
              ) : (
                <form className="flex flex-1 flex-col justify-center gap-3.5" onSubmit={handleSubscribe} noValidate>
                  <label className="mt-1 text-[14px] font-medium tracking-[0.01em] text-white" htmlFor="pub-full-name">Full Name</label>
                  <input id="pub-full-name" type="text" className="h-[42px] w-full rounded-[6px] border border-[#4b5872]/65 bg-[#384255] px-3.5 text-[14px] text-white placeholder:text-[#9aa4b8] focus:border-[#6aa4ff] focus:bg-[#3d4860] focus:outline-none transition-colors" placeholder="Enter your full name" value={formData.fullName} onChange={(e) => setFormData((f) => ({ ...f, fullName: e.target.value }))} required />
                  <label className="mt-1 text-[14px] font-medium tracking-[0.01em] text-white" htmlFor="pub-email">Email Address</label>
                  <input id="pub-email" type="email" className="h-[42px] w-full rounded-[6px] border border-[#4b5872]/65 bg-[#384255] px-3.5 text-[14px] text-white placeholder:text-[#9aa4b8] focus:border-[#6aa4ff] focus:bg-[#3d4860] focus:outline-none transition-colors" placeholder="Enter your email address" value={formData.email} onChange={(e) => setFormData((f) => ({ ...f, email: e.target.value }))} required />
                  <button type="submit" className="mt-4 w-full rounded-[6px] border border-white/80 bg-white px-4 py-[11px] text-[14px] font-medium text-[#1a2236] shadow-[0_8px_18px_rgba(255,255,255,0.08)] transition-all hover:bg-[#f7f9fc]">Subscribe for Updates</button>
                  <p className="mt-2 text-[12px] italic text-[#a9b2c3]">By subscribing, you agree to receive updates about new publications, white papers, and related resources.</p>
                </form>
              )}
            </div>
          </div>
        </div>
      </section> */}

				<Footer />
			</div>
		</div>
	);
};

export default PublicationsPage;
